import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
Vue.use(Vuex);

const roundWeight = (value) => Math.round(Number(value) * 10) / 10;

const state = {
  sidebarShow: "responsive",
  sidebarMinimize: false,
  weightHistory: [],
  maxCalories: 1900,
  minSleep: 7.5,
  withingsClientId: null,
  fitbitClientId: null,
  googleHealthConfigured: false,
  googleHealthConnected: false,
  calories: [],
  sleep: [],
};

const mutations = {
  initializeWeights(state, weights) {
    state.weightHistory = weights.map((w) => {
      return { date: moment(w.date).startOf("day"), value: w.value };
    });
  },

  calories(state, calories) {
    state.calories = calories;
  },

  withings(state, clientId) {
    state.withingsClientId = clientId;
  },

  fitbit(state, clientId) {
    state.fitbitClientId = clientId;
  },

  googleHealth(state, status) {
    state.googleHealthConfigured = Boolean(status?.configured);
    state.googleHealthConnected = Boolean(status?.connected);
  },

  limits(state, limits) {
    state.maxCalories = limits?.calories ?? state.maxCalories;
    state.minSleep = limits?.sleep ?? state.minSleep;
  },

  sleep(state, sleep) {
    state.sleep = sleep;
  },

  addNewWeight(state, { value, date }) {
    const roundedValue = roundWeight(value);
    let existingWeight = state.weightHistory.find((w) => date.isSame(w.date));
    if (existingWeight) {
      existingWeight.value = roundedValue;
    } else {
      state.weightHistory.push({ value: roundedValue, date: moment(date).startOf("day") });
    }
  },
};

export default new Vuex.Store({
  state,
  mutations,
});
